import { useEffect, useRef } from 'react';
import type { DashboardPageProps } from '../../../lib/dashboard-page';

export function LogoutPage({ handlers }: DashboardPageProps) {
  const { authHandler, navigationHandler } = handlers;
  const hasRun = useRef<boolean>(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    async function logout() {
      await authHandler.logout();
      navigationHandler.navigate('/login', { excludeSiteId: true, excludeSiteEnv: true });
    }

    logout();
  }, [authHandler, navigationHandler]);

  return null;
}
